import { translate } from "@flow-frontend-npm/common";
import t from "../translations.json";

export const ConfirmationStatus = {
    READY: {
        name: "READY",
        modalOpen: true,
        buttonsActive: true,
    },
    SENDING: {
        name: "SENDING",
        modalOpen: false,
        buttonsActive: false,
    },
    ERROR: {
        name: "ERROR",
        message: translate(t, "status.error"),
        modalOpen: true,
        buttonsActive: true,
    },
    UPDATING: {
        name: "UPDATING",
        message: translate(t, "status.updating"),
        modalOpen: true,
        buttonsActive: false,
    },
    CLOSED: {
        name: "CLOSED",
        modalOpen: false,
        buttonsActive: false,
    },
};

export const DIALOG_DEFAULTS = {
    // Add your default dialog properties here
    allowClose: false,
    reloadPageAfterScan: false,
};
